import PropTypes from "prop-types";
import { Component } from "react";
import { Mention, MentionsInput } from "react-mentions-ts";
import Avatar from "@shared/v2/Avatar";
import { uniqBy } from "lodash";
import mentionInputClassNames from "./mentionInputClassNames";

const filterMentionableUsers = (mentionableUsers, query) =>
  uniqBy(mentionableUsers, "id")
    .filter((p) => p.display.toLowerCase().startsWith(query.toLowerCase()))
    .sort((a, b) => a.display.toLowerCase().localeCompare(b.display.toLowerCase()));

class MentionablePersonTextArea extends Component {
  constructor(props) {
    super(props);
    this.state = { mentionableUsers: null };
  }

  getMentionableUsers = async (query) => {
    const { mentionableUsers } = this.state;
    const { mentionable_id: mentionableId, mentionable_type: mentionableType, isUuid } = this.props;
    if (!mentionableUsers) {
      return fetch(
        `/mentions/mentionable_people?${
          isUuid ? "mentionable_uuid" : "mentionable_id"
        }=${mentionableId}&mentionable_type=${mentionableType}`,
      )
        .then((res) => res.json())
        .then((res) => {
          const mu = res.map((p) => ({ ...p, display: p.full_name }));
          this.setState({ mentionableUsers: mu });
          return filterMentionableUsers(mu, query);
        })
        .catch(() => []);
    }
    return filterMentionableUsers(mentionableUsers, query);
  };

  render() {
    const { id, className, classNames, disabled, value, placeholder, onChange, isExternal } = this.props;
    return (
      <MentionsInput
        id={id}
        className={className}
        classNames={Object.keys(mentionInputClassNames).reduce((acc, key) => {
          acc[key] = `${mentionInputClassNames[key]} ${classNames?.[key] || ""}`;
          return acc;
        }, {})}
        disabled={disabled}
        value={value}
        placeholder={placeholder || "Write a note or use @ to mention someone..."}
        onMentionsChange={({ value: v }) => onChange(v)}
        readOnly={isExternal}
        spellCheck
      >
        <Mention
          trigger="@"
          data={this.getMentionableUsers}
          displayTransform={(_, display) => `@${display}`}
          markup="[__display__](__id__)"
          className="tw-text-theme-primary"
          style={{ WebkitTextStroke: "0.02em currentColor" }}
          renderSuggestion={(suggestion, search, highlightedDisplay) => (
            <div className="tw-flex tw-flex-row tw-items-center">
              <Avatar src={suggestion.avatar} alt={suggestion.full_name} />
              <div className="tw-ml-2">{highlightedDisplay}</div>
            </div>
          )}
        />
      </MentionsInput>
    );
  }
}

MentionablePersonTextArea.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  classNames: PropTypes.shape({
    input: PropTypes.string,
    highlighter: PropTypes.string,
    suggestions: PropTypes.string,
    suggestion: PropTypes.string,
    focusedSuggestion: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isExternal: PropTypes.bool,
  mentionable_id: PropTypes.string.isRequired,
  mentionable_type: PropTypes.string.isRequired,
  isUuid: PropTypes.bool,
};

MentionablePersonTextArea.defaultProps = {
  className: "",
  classNames: {},
  disabled: false,
  value: "",
  placeholder: "",
  isExternal: false,
  isUuid: false,
};

export default MentionablePersonTextArea;
